export const FLEXIBLE_DATES_RANGE = 2;
